"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class RolesProvider extends DataProvider_1.default {
    getStats() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("statsRoles", undefined, "... on StatsData { info }");
        });
    }
}
exports.RolesProvider = RolesProvider;
//# sourceMappingURL=RolesProvider.js.map